// extracted by mini-css-extract-plugin
module.exports = {"news":"Blogs_news__OnUlL","container":"Blogs_container__jrUZP"};